// src/themes/desert-sky.ts
import { Theme } from "./types";

export const desertSkyTheme: Theme = {
  "background-light": "245 235 220", // #F5EBDC - Warm sand
  "background-dark": "235 225 210", // #EBE1D2 - Soft sand
  "card-light": "255 250 240", // #FFFAF0 - Cream
  "card-dark": "250 245 235", // #FAF5EB - Warm cream
  "input-light": "240 230 215", // #F0E6D7 - Light sand
  "input-dark": "230 220 205", // #E6DCCD - Soft sand
  "border-light": "210 180 140", // #D2B48C - Tan border
  "border-dark": "200 170 130", // #C8AA82 - Warm tan
  primary: "65 105 225", // #4169E1 - Royal blue
  "primary-hover": "70 130 255", // #4682FF - Bright blue
  text: "60 45 30", // #3C2D1E - Dark brown
  "text-dark": "70 55 40", // #463728 - Rich brown
  "text-secondary": "120 100 80", // #786450 - Muted brown
  "text-secondary-dark": "100 80 60", // #64503C - Warm brown
};
